<div class="work-item-lane">
  <app-work-item-widget [workItem]="workItem"></app-work-item-widget>

  <div class="click-area" *ngIf="!isFocused()" (click)="onActivateClick()"></div>
</div>
